import Requests from './requests'
import UserPerms from './userPerms'
import Links from './links'
import { sprintf } from 'sprintf-js'

export default class Users extends Requests {

  me () {
    let self = this
    if (self._me !== undefined) {
      return self._me
    }
    return self._getOne('me')
      .then(function (me) {
        self._me = me
        return self._me
      })
      .catch(function () {
        self._me = null
        return null
      })
  }

  list (page = 1, query = '', sort = '', perPage = 0, count = false) {
    return this._getMany(page, query, sort, perPage, count)
  }

  get (id) {
    return this._getOne(id)
  }

  create (user) {
    return this._create(user)
  }

  update (user) {
    return this._update(user)
  }

  delete (id) {
    return this._delete(id)
  }

  perms (userId) {
    return new UserPerms(sprintf('users/%s/perms', userId), this.backd)
  }

  roles (userId) {
    return this._getURL(sprintf('%s/roles', userId))
  }

  setRoles (userId, roles) {
    return this._updateURL(sprintf('%s/roles', userId), roles)
  }

  links (userId) {
    return new Links(sprintf('users/%s', userId), this.backd)
  }

}



// WEBPACK FOOTER //
// ./src/users.js